// extracted by mini-css-extract-plugin
export default {"bnrs":"FeaturesBlock_bnrs__ckq3G","block":"FeaturesBlock_block__uBqIL","empty":"FeaturesBlock_empty__DttKr","btnLine":"FeaturesBlock_btnLine__TYKhX"};